import { type ErrorInfo } from 'react';

export type SupportedProduct = 'confluence' | 'jira';

export type ErrorHandlerProps = {
	error: Error;
	errorInfo: ErrorInfo;
	product: SupportedProduct;
	source?: string;
};

export type ModalDismissalMethod = 'modalOverlayClick' | 'secondaryCTAButton' | 'closeButton';

export type TrialHistoryType = 'REVERSE_TRIAL' | null;

export type OfferShownType = 'PREMIUM_PLANS' | 'AI';

export type ModalShownPreOrPostUpgrade = 'PRE_UPGRADE' | 'POST_UPGRADE';

export type CommonAnalyticsAttributes = {
	modalShownPrePostUpgrade: ModalShownPreOrPostUpgrade;
	offerShown: OfferShownType;
	product: SupportedProduct;
};

export type BusinessLogicAnalyticsAttributes = Record<string, unknown>;

export const CONFLUENCE_STANDARD_OFFER_AI_MODAL = 'ConfluenceStandardOfferAIModal';

export const CONFLUENCE_AFTER_STANDARD_UPGRADE_AI_MODAL = 'ConfluenceAfterStandardUpgradeAIModal';

export const JIRA_PREMIUM_OFFER_AI_MODAL = 'JiraPremiumOfferAIModal';

export const JIRA_PREMIUM_PLANS_MODAL = 'JiraPremiumPlansModal';
